import React from 'react';
import { TableHead } from '@getsynapse/design-system';
import intl from 'react-intl-universal';
import { USER_DRILLDOWN_TABLE_SORTABLE_COLUMNS } from 'utils/constants/dashboard';

type UserDrillDownTableHeaderProps = {
  handleSort: (column: string) => void;
};

const UserDrillDownTableHeader: React.FC<UserDrillDownTableHeaderProps> = ({
  handleSort,
}) => {
  const headCells = [
    {
      'data-cy': 't-header__Request',
      columnName: USER_DRILLDOWN_TABLE_SORTABLE_COLUMNS.NAME,
      content: intl.get('DASHBOARDS_USER_TABLE_DRILLDOWN_PAGE.TABLE.HEAD.NAME'),
    },
    {
      'data-cy': 't-header__Request',
      columnName: USER_DRILLDOWN_TABLE_SORTABLE_COLUMNS.TIME_OFF,
      content: intl.get(
        'DASHBOARDS_USER_TABLE_DRILLDOWN_PAGE.TABLE.HEAD.TIME_OFF'
      ),
    },
    {
      'data-cy': 't-header__Request',
      columnName: USER_DRILLDOWN_TABLE_SORTABLE_COLUMNS.DEFAULT_CAPACITY_HOURS,
      content: intl.get(
        'DASHBOARDS_USER_TABLE_DRILLDOWN_PAGE.TABLE.HEAD.DEFAULT_CAPACITY_HOURS'
      ),
    },
    {
      'data-cy': 't-header__Request',
      columnName: USER_DRILLDOWN_TABLE_SORTABLE_COLUMNS.CAPACITY_HOURS,
      content: intl.get(
        'DASHBOARDS_USER_TABLE_DRILLDOWN_PAGE.TABLE.HEAD.CAPACITY_HOURS'
      ),
    },
    {
      'data-cy': 't-header__Request',
      columnName: USER_DRILLDOWN_TABLE_SORTABLE_COLUMNS.ALLOCATED_HOURS,
      content: intl.get(
        'DASHBOARDS_USER_TABLE_DRILLDOWN_PAGE.TABLE.HEAD.ALLOCATED_HOURS'
      ),
    },
    {
      'data-cy': 't-header__Request',
      columnName: USER_DRILLDOWN_TABLE_SORTABLE_COLUMNS.ACTUAL_HOURS,
      content: intl.get(
        'DASHBOARDS_USER_TABLE_DRILLDOWN_PAGE.TABLE.HEAD.ACTUAL_HOURS'
      ),
    },

    {
      'data-cy': 't-header__Request',
      columnName: USER_DRILLDOWN_TABLE_SORTABLE_COLUMNS.AVAILABLE_HOURS,
      content: intl.get(
        'DASHBOARDS_USER_TABLE_DRILLDOWN_PAGE.TABLE.HEAD.AVAILABLE_HOURS'
      ),
    },
    {
      'data-cy': 't-header__Request',
      columnName: USER_DRILLDOWN_TABLE_SORTABLE_COLUMNS.SCHEDULED_HOURS,
      content: intl.get(
        'DASHBOARDS_USER_TABLE_DRILLDOWN_PAGE.TABLE.HEAD.SCHEDULED_HOURS'
      ),
    },

    {
      'data-cy': 't-header__Request',
      columnName: USER_DRILLDOWN_TABLE_SORTABLE_COLUMNS.JOB_TITLE,
      content: intl.get(
        'DASHBOARDS_USER_TABLE_DRILLDOWN_PAGE.TABLE.HEAD.JOB_TITLE'
      ),
    },
    {
      'data-cy': 't-header__Request',
      columnName: USER_DRILLDOWN_TABLE_SORTABLE_COLUMNS.JOB_FUNCTIONS,
      content: intl.get(
        'DASHBOARDS_USER_TABLE_DRILLDOWN_PAGE.TABLE.HEAD.JOB_FUNCTIONS'
      ),
    },
    {
      'data-cy': 't-header__Request',
      columnName: USER_DRILLDOWN_TABLE_SORTABLE_COLUMNS.SKILLS,
      content: intl.get(
        'DASHBOARDS_USER_TABLE_DRILLDOWN_PAGE.TABLE.HEAD.SKILLS'
      ),
    },
    {
      'data-cy': 't-header__Request',
      columnName: USER_DRILLDOWN_TABLE_SORTABLE_COLUMNS.LEARNING_TEAMS,
      content: intl.get(
        'DASHBOARDS_USER_TABLE_DRILLDOWN_PAGE.TABLE.HEAD.LEARNING_TEAMS'
      ),
    },
    {
      'data-cy': 't-header__Request',
      columnName: USER_DRILLDOWN_TABLE_SORTABLE_COLUMNS.TYPE,
      content: intl.get('DASHBOARDS_USER_TABLE_DRILLDOWN_PAGE.TABLE.HEAD.TYPE'),
    },
    {
      'data-cy': 't-header__Request',
      columnName: USER_DRILLDOWN_TABLE_SORTABLE_COLUMNS.ROLE,
      content: intl.get('DASHBOARDS_USER_TABLE_DRILLDOWN_PAGE.TABLE.HEAD.ROLE'),
    },
    {
      'data-cy': 't-header__Request',
      columnName: USER_DRILLDOWN_TABLE_SORTABLE_COLUMNS.EMAIL,
      content: intl.get(
        'DASHBOARDS_USER_TABLE_DRILLDOWN_PAGE.TABLE.HEAD.EMAIL'
      ),
    },
    {
      'data-cy': 't-header__Request',
      columnName: USER_DRILLDOWN_TABLE_SORTABLE_COLUMNS.CREATED_AT,
      content: intl.get(
        'DASHBOARDS_USER_TABLE_DRILLDOWN_PAGE.TABLE.HEAD.CREATED_AT'
      ),
    },
    {
      'data-cy': 't-header__Request',
      columnName: USER_DRILLDOWN_TABLE_SORTABLE_COLUMNS.LAST_LOGIN_DATE,
      content: intl.get(
        'DASHBOARDS_USER_TABLE_DRILLDOWN_PAGE.TABLE.HEAD.LAST_LOGIN_DATE'
      ),
    },
    {
      'data-cy': 't-header__Request',
      columnName: USER_DRILLDOWN_TABLE_SORTABLE_COLUMNS.DISABLED_AT,
      content: intl.get(
        'DASHBOARDS_USER_TABLE_DRILLDOWN_PAGE.TABLE.HEAD.DISABLED_AT'
      ),
    },
  ];

  return (
    <TableHead stickyHeader handleSort={handleSort} headCells={headCells} />
  );
};

export default UserDrillDownTableHeader;
